import { Filter, FilterProps, ReferenceInput, SelectInput, DateInput } from 'react-admin';
import FilterSearchOnButtonPress from '@/components/filters/FilterSearchOnButtonPress';
import { MONITORING_STATUS_FILTER_CHOICES, PROFILE_STATUS_FILTER_CHOICES } from '@/pages/Candidate/constants';
import { PartnerInputStyled } from '@/styles/overrides';
import { TurnReferencesEnum } from '@/types/turn-enums';

const CandidateFilter = (props: Partial<FilterProps>) => (
  <Filter {...props}>
    <ReferenceInput
      label="Partner"
      source="partner__id"
      reference={TurnReferencesEnum.AdminPartners}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <PartnerInputStyled optionText="name" optionValue="id" translateChoice={false} />
    </ReferenceInput>
    <SelectInput
      emptyText="All"
      label="Profile Status"
      source="profile_status"
      choices={PROFILE_STATUS_FILTER_CHOICES}
    />
    <DateInput label="Consent Date" source="consent_date" />
    <SelectInput
      emptyText="All"
      label="Monitoring Status"
      source="monitoring_status"
      choices={MONITORING_STATUS_FILTER_CHOICES}
    />

    <FilterSearchOnButtonPress source="q" label="Search" alwaysOn showSearchHelp />
  </Filter>
);

export default CandidateFilter;
